export enum EntityStoreKey {
  TellentImpactTracker = 'tellentImpactTracker',
}

export type TellentImpactInsightName =
  | 'candidates_and_hires'
  | 'views_and_conversion'
  | 'automations'
  | 'active_and_new_users'
  | 'actions_performed'
  | 'postings_and_job_boards';

export type TellentImpactInsight = {
  name: TellentImpactInsightName;
  position: number;
  values: [number, number];
  visible: boolean;
};

export type TellentImpactTrackerData = {
  insights: TellentImpactInsight[];
  kind: string; // 'recruitment'
  showDialogBanner: boolean;
  showMenuBanner: boolean;
  total: number;
};
